import React from 'react';

function Footer() {
    let yr = new Date().getFullYear();
    return (
        <footer>
            <p>Anmol Baranwal © {yr}</p>
        </footer>
    );
}

export default Footer;